export default __webpack_public_path__ + "static/sparkle_logo_blue-20df1667ff9b6919617145bf4b117049.png";